import { get } from '../Services/http';
import { catchError } from './Error.action';
import {
    FACETED_SEARCH_QUERY,
    FACETED_SEARCH_ERROR,
    LOADMORE_SET_LOADED,
    LOADMORE_SET_PAGINATION_INFO,
} from '../constants';

export const query = (queryString = '', prev) => (dispatch, getState) => {
    let url = '/api/product/loadMoreProducts';

    if (queryString && queryString.trim() !== '') {
        url += `?${queryString}`;
    }
    dispatch(setLoaded(false));
    return get(url)
        .then((response) => response.json())
        .then((result) => {
            const list = document.querySelector(
                '#search-result div.product-list-category .product-list'
            );
            let dom = new DOMParser().parseFromString(
                result.productsView,
                'text/html'
            );
            const view = dom.querySelector('ul.product-list');
            const { currentPageIndex } = view.querySelector('.spann').dataset;

            list.insertAdjacentHTML(
                prev ? 'afterbegin' : 'beforeend',
                view.innerHTML
            );
            if (document.querySelector('#temp-space')) {
                document.querySelector('#temp-space').remove();
            }

            if (prev) {
                const id = parseInt(currentPageIndex) + 1;
                const scrolledEl = document.querySelector(`#list-${id}`);
                const currEl = document.querySelector(
                    `#list-${currentPageIndex}`
                );
                if (currEl && scrolledEl) {
                    const elemBottom = scrolledEl.getBoundingClientRect().top;
                    const elemTop = currEl.getBoundingClientRect().top;
                    window.scrollTo(0, elemBottom - elemTop);
                }
            }
            const newPager = dom.querySelector('#pager ul.pagination');
            if (newPager) {
                newPager.parentNode.removeChild(newPager);
                const oldPager = document.querySelector('ul.pagination');
                oldPager.parentNode.replaceChild(newPager, oldPager);
            }
            window.__litium.bootstrapComponents();
            dispatch(setPaginationInfo(currentPageIndex));
            dispatch(setLoaded(true));
        })
        .catch((ex) => dispatch(catchError(ex, (error) => searchError(error))));
};

export const loadMore = (pageNumber, prev) => (dispatch, getState) => {
    let q = new URLSearchParams(window.location.search);
    q.set('page', pageNumber);
    q = q.toString();

    return dispatch(query(q, prev));
};

export const searchError = (error) => ({
    type: FACETED_SEARCH_ERROR,
    payload: {
        error,
    },
});

export const saveQuery = (queryString) => ({
    type: FACETED_SEARCH_QUERY,
    payload: {
        query: queryString,
    },
});

export const setPaginationInfo = (currentPageIndex) => ({
    type: LOADMORE_SET_PAGINATION_INFO,
    payload: {
        currentPageIndex,
    },
});

export const setLoaded = (loaded) => ({
    type: LOADMORE_SET_LOADED,
    payload: {
        loaded,
    },
});
